__turbopack_context__.v({
  "skeletonRow": "skeletonRows-module-scss-module__EPXKbG__skeletonRow",
});
